{
  "names": {
    "Fajr": "Subuh",
    "Dhuhr": "Zohor",
    "Asr": "Asar",
    "Maghrib": "Maghrib",
    "Isha": "Isyak"
  },
  "card": {
    "label": "Solat seterusnya",
    "labelTomorrow": "Esok · {{prayer}}",
    "inHoursMinutes": "dalam {{hours}} j {{minutes}} min",
    "inMinutes": "dalam {{minutes}} min",
    "open_aria": "Buka waktu solat",
    "pro": "Rhemn Pro",
    "unlock_aria": "Buka kunci waktu solat dengan Rhemn Pro",
    "unavailable": "Waktu solat tidak tersedia buat masa ini."
  },
  "sheet": {
    "bellOn_aria": "Matikan peringatan {{prayer}}",
    "bellOff_aria": "Hidupkan peringatan {{prayer}}",
    "explainer": "Dapatkan peringatan lembut pada setiap solat. Peringatan ialah pemberitahuan senyap — tiada bunyi secara lalai.",
    "enableReminders": "Aktifkan peringatan",
    "enableInSettings": "Aktifkan pemberitahuan Rhemn dalam Tetapan untuk menerima peringatan solat.",
    "openSettings": "Buka Tetapan"
  },
  "notifications": {
    "body": "Sudah masuk waktu solat."
  },
  "focus": {
    "label": "Solat {{prayer}}",
    "close_aria": "Tutup skrin solat",
    "hint": "Tekan Esc atau × untuk kembali",
    "phrases": {
      "accepted": "Semoga Allah menerima solat anda",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "Mulakan dengan niat. Teruskan dengan barakah.",
    "prayerApproaches": "Waktu solat anda yang seterusnya menghampiri. Kekal teguh dalam niat anda.",
    "morningPursue": "Pagi yang diberkati untuk dikejar: {{focus}}",
    "dayCloses": "Ketika hari menutup tirai, renungkanlah: {{focus}}",
    "fulfilled": "Anda telah menunaikan niat anda hari ini. Alhamdulillah.",
    "workingTowards": "Hari ini anda sedang berusaha ke arah: {{focus}}",
    "prayerNear": "Waktu solat anda yang seterusnya sudah dekat. Tarik nafas."
  },
  "widget": {
    "countdown": "dalam {{time}}",
    "openToUpdate": "Buka Rhemn untuk mengemas kini",
    "openForVerse": "Buka Rhemn untuk ayat hari ini"
  }
}
